import React, {memo} from "react";
import PropTypes from "prop-types";
import {Chip} from "@mui/material";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import {isImageFile} from "../../resources/utils/imageUtils";

const MessageAttachmentChip = memo(({fileName, id}) => {
  if (!fileName) {
    return null;
  }

  const icon = isImageFile(fileName) ?
    (
      <ImageOutlinedIcon fontSize="small" />
    ) :
    (
      <InsertDriveFileOutlinedIcon fontSize="small" />
    );

  return (
    <Chip
      icon={icon}
      label={fileName}
      size="small"
      id={`message-attach-chip-${id || "single"}`}
      sx={{
        mt: 1,
        color: "primary.contrastText",
        borderColor: "primary.contrastText",
        maxWidth: "100%",
        "& .MuiChip-icon": {
          color: "primary.contrastText",
        },
        "& .MuiChip-label": {
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      }}
    />
  );
});

MessageAttachmentChip.displayName = "MessageAttachmentChip";

MessageAttachmentChip.propTypes = {
  fileName: PropTypes.string,
  id: PropTypes.string,
};

export default MessageAttachmentChip;
